import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ValidateFiscalCodeFailure, ValidateFiscalCodeRequest, ValidateFiscalCodeSuccess } from './actions';
import { ValidateFiscalCode, ValidationResponse } from '@models/swagger';
import { ValidateFiscalCodeParams, ValidateFiscalCodeService } from './service';

@Injectable()
export class ValidateFiscalCodeEffects {
  private readonly actions$ = inject(Actions);
  private readonly validateFiscalCodeService = inject(ValidateFiscalCodeService);

  validateFiscalCode$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ValidateFiscalCodeRequest),
      switchMap(({ body, parameters }: { body: ValidateFiscalCode; parameters?: ValidateFiscalCodeParams }) =>
        this.validateFiscalCodeService.validateFiscalCode(body, parameters).pipe(
          map((data: ValidationResponse) => ValidateFiscalCodeSuccess({ data })),
          catchError(error => of(ValidateFiscalCodeFailure({ error })))
        )
      )
    )
  );

}
